"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IListPrice } from "@/interfaces/list-price.interface";
import { listPriceService } from "@/services/list-price.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetListPriceByIdReturn = RequestsBaseReturn<IListPrice | null>;

export type UseGetListPriceByIdProps = ByIdRequestProps;

type UseSwrGetListPriceByIdParams = [string, number] | null;

const useGetListPriceById = ({ _id }: UseGetListPriceByIdProps): UseGetListPriceByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<IListPrice, Error, UseSwrGetListPriceByIdParams>(
    _id ? [SWR_KEYS.getListPriceById, _id] : null,
    ([, listPriceId]) => listPriceService.getById(listPriceId),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetListPriceById;
